export enum OrientationOption {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}
